module.exports = __webpack_public_path__ + "media/country_flags/nl-b95ad5e3.png";